<template>
	<div>
		<div class="data">
			<div v-if="nodata == true" class="alert alert-primary text-center" role="alert">{{ mensaje }}</div>
			<div class="tabla" v-if="nodata == false && documentos.length > 0">
				<div class="data">
					<b-table striped head-variant="light" :items="getDocumentos" :fields="columnas">
						<template #cell(detalle)="row">
							<b-button variant="link" size="sm" style="color: black; font-size: 12px" @click="row.toggleDetails" class="mr-2"><i class="fas fa-plus fa-fw" /></b-button>
						</template>
						<template #cell(totalAmount)="row">{{ Intl.NumberFormat("es-CL").format(row.value) }}</template>
						<template #cell(MONTO_TOTAL)="row">{{ Intl.NumberFormat("es-CL").format(row.value) }}</template>
						<template #cell(diferencia)="row">{{ Intl.NumberFormat("es-CL").format(row.value) }}</template>
						<template #row-details="row">
							<div style="font-size: 12px">
								<b-table striped :items="row.item.children" :fields="detalle">
									<template #cell(id_documentType)="r">{{ getBsale(r.value) }}</template>
									<template #cell(totalAmount)="r">{{ Intl.NumberFormat("es-CL").format(r.value) }}</template>
									<template #cell(MONTO_FACTURA)="r">{{ Intl.NumberFormat("es-CL").format(r.value) }}</template>
									<template #cell(MONTO_NOTA_CREDITO)="r">{{ Intl.NumberFormat("es-CL").format(r.value) }}</template>
									<template #cell(MONTO_TOTAL)="r">{{ Intl.NumberFormat("es-CL").format(r.value) }}</template>
									<template #cell(diferencia)="r">{{ Intl.NumberFormat("es-CL").format(r.value) }}</template>
								</b-table>
							</div>
						</template>
					</b-table>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import moment from "moment"
	import $ from "jquery"
	import bsale from "./../../bsale.json"


	export default 
	{
		name: "Diferencias",
		props: {
			info: String,
		},
		data() {
			return {
				periodo: "",
				nodata: false, // Flag que indica si la respuesta del ws trajo datos o no, para mostrar el mensaje en la pantalla
				mensaje: "",
				documentos: [], // Arreglo con el total de documentos del periodo
				columnas: [ 
					{ key: "detalle", label: "", sortable: false },
					{ key: "ES_id_of", label: "Es Id Of", sortable: true, },
					{ key: "CLIENTE_NAME", label: "Client Name", sortable: true, class: "text-nowrap" }, 
					{ key: "code", label: "Code", sortable: true, class: "text-nowrap" }, 
					{ key: "grupo_economico", label: "Grupo Económico", sortable: true, class: "text-nowrap" },
					{ key: "totalAmount", label: "Total Amount", sortable: true, class: "text-right" },
					{ key: "MONTO_TOTAL", label: "Monto Total", sortable: true, class: "text-right" },
					{ key: "diferencia", label: "Diferencia", sortable: true, class: "text-right" },
				],
				detalle: [ 
					{ key: "id_documentType", label: "Tipo de Documento", sortable: true, class: "text-nowrap" },
					{ key: "number", label: "Number", sortable: true, class: "text-right" },
					{ key: "totalAmount", label: "Total Amount", sortable: true, class: "text-right" },
					{ key: "MONTO_FACTURA", label: "Monto Factura", sortable: true, class: "text-right" },
					{ key: "MONTO_NOTA_CREDITO", label: "Monto Nota Crédito", sortable: true, class: "text-right" },
					{ key: "MONTO_TOTAL", label: "Monto Total", sortable: true, class: "text-right" },
					{ key: "diferencia", label: "Diferencia", sortable: true, class: "text-right" },
				],
				perPage: 10,
				currentPage: 1,
			}
		},
		created() {

			this.periodo = this.$periodo
		},
		computed: {

			getDocumentos() {

				return this.getDoctos()
			},

			totalDoctos() {

				return this.getDoctos().length
			},
		},
		mounted: function() {

			// Guardamos el THIS en otra variable para poder usarla aqui. No se puede usar directamente THIS en esta parte del ciclo de vida (?????)
			const that = this

			// Escuchamos por el evento "cambio-periodo", que se genera desde el componente HEADER y lo envia a todos los componentes activos
			// Actualizamos la variable local periodo y actualizamos la data

			window.event.$on("evento-cambio-periodo", function(periodo) {

				// Leemos los datos a traves del servicio rest
				that.periodo = periodo
			})

			this.leerDatos()
		},
		methods: {

			leerDatos() {

				// Ocultamos el panel con los dtos y mostramos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

                // Llamamos al WS para traer las fichas a mostrar
				var request = { 
					"usuario": this.$usuario,
					"destino": this.$env,
					"tx": "iF", 
					"operacion": "iF_periodo", 
					"data2Query": {
						"fecha_de_desde": this.periodo.substr(0, 7),
						"fecha_de_hasta": this.periodo.substr(0, 7),
					}
				}

				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					// Chequeamos si existe la propiedad mensaje_error
					// Si existe es porque hubo un problema en la llamada o no hay datos y mostramos el mensaje
					if (response.data.estatus != "OK") {

						this.nodata = true
						this.mensaje = response.data.mensajer_error
					} else {

						this.nodata = false
						this.mensaje = ""

						this.procesar(response.data.data)
					}

					// Ocultamos la imagen cargando y mostramos el panel con los datos
					window.event.$emit("mostrar-cargando", false)

				}).catch(ex => { 

					// Si hubo un error, pasamos por aca
					console.log(ex.message) 

					// Ocultamos la imagen cargando y mostramos el panel con los datos
					window.event.$emit("mostrar-cargando", false)
				})
			},

			procesar(data) {

				var that = this
				var datos = []
				data.forEach(function(registro) {

					var existe = false
					var index = -1;
					datos.forEach(function(d, idx) {

						if (d.ES_id_of == registro.ES_id_of)
						{
							existe = true
							index = idx
	
							return false
						}
					})
	
					if (!existe) {

						registro["diferencia"] = 0

						datos.push({ 
							ES_id_of: registro.ES_id_of, 
							totalAmount: registro.totalAmount, 
							CLIENTE_NAME: registro.CLIENTE_NAME, 
							code: registro.code, 
							group_economico: registro.grupo_economico,
							MONTO_FACTURA: registro.MONTO_FACTURA,
							MONTO_NOTA_CREDITO: registro.MONTO_NOTA_CREDITO,
							MONTO_TOTAL: registro.MONTO_TOTAL,
							diferencia: 0,
							children: [ registro ] 
						})
					} else {

						registro["diferencia"] = 0

						var amount = registro.totalAmount
						if (registro.id_documentType == "2")
						{
							amount *= -1
							registro.totalAmount = amount
						}
	
						datos[index].totalAmount += amount
						datos[index].diferencia = datos[index].MONTO_TOTAL - datos[index].totalAmount
						datos[index].children.push(registro)
					}
				})

				this.documentos = datos.filter(function(documento) {

					return documento.children.length > 1
				})
			},

			getBsale(id) {

				var name = id 
				bsale.forEach(function(docto) {

					if (docto.codigo == id)
					{
						name = docto.nombre
						return false
					}
				})

				return name
			},

			getFecha(unix) {

				return moment.unix(unix).utc().format("DD-MM-YYYY")
			},

			getDoctos() {

                return this.documentos.filter(function(documento) {

					return documento.children.length > 1
				})
			},
		}
	}
</script>
<style scoped>

	.titulo {
		width: 100%;
		margin-bottom: 15px;
	}

	.tabla {
		width: 100%;
	}

	.data {
		overflow: auto;
		font-size: 14px;
	}

	col-body {
		width: 300px;
	}

</style>
